import React from "react"
import { Box } from "@chakra-ui/react"
import { BadgeShapeData } from "sharedTypes/badge"

type Props = {
  width: number
  height: number
  scaleFactor: number
  children: React.ReactNode
}

export const getShapeStrokeProps = (data: BadgeShapeData, thicknessPx: number) => ({
  fill: data.fillColor === "transparent" ? "none" : data.fillColor,
  stroke: data.strokeColor === "transparent" ? "none" : data.strokeColor,
  strokeWidth: thicknessPx,
  strokeDasharray:
    data.style === "dashed"
      ? `${thicknessPx * 3} ${thicknessPx * 2}`
      : data.style === "dotted"
        ? `${thicknessPx} ${thicknessPx}`
        : undefined,
})

const ShapeSVGWrapper = ({
  width, height, scaleFactor, children,
}: Props) => (
  <Box w="full" h="full" position="relative">
    <svg
      width="100%"
      height="100%"
      viewBox={`0 0 ${width * scaleFactor} ${height * scaleFactor}`}
      preserveAspectRatio="none"
      style={{ position: "absolute", top: 0, left: 0 }}
    >
      {children}
    </svg>
  </Box>
)

export default ShapeSVGWrapper
